import { fql } from 'fauna';

export const getGeneralSettingV10 = async (client) => {
  const response = await client.query(fql`GeneralSetting.byId(${process.env.REACT_APP_PERIOD_SETTING})`);
  return response.data;
}